import React from "react";

import { Link } from "react-router-dom";

import { makeStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Tooltip from "@material-ui/core/Tooltip";

import {
  Contactless,
  Person,
  Home,
  Subject,
  Face,
  Apps,
  Policy,
  CardMembership,
  Work
} from "@material-ui/icons";

import Button from "components/CustomButtons/Button.js";
import MyResume from "../../assets/resume/RachitResume2021Latest.pdf";
import styles from "assets/jss/material-kit-react/components/headerLinksStyle.js";

import CustomDropdown from "components/CustomDropdown/CustomDropdown.js";

const useStyles = makeStyles(styles);

export default function HeaderLinks(props) {
  const classes = useStyles();
  return (
    <List className={classes.list}>
      <ListItem className={classes.listItem}>
        <Link to="/" color="transparent" className={classes.navLink}>
          <Home className={classes.icons} />
          Home
        </Link>

        <Link to="/biteinsurance" color="rose" className={classes.navLink}>
          <Policy className={classes.icons} />
          Bite Insurance
        </Link>

        <Link to="/mycertificates" color="rose" className={classes.navLink}>
          <CardMembership className={classes.icons} />
          Hall Of Fame
        </Link>

        <Link to="/mywork" color="rose" className={classes.navLink}>
          <Work className={classes.icons} />
          My Work
        </Link>



      </ListItem>

      <ListItem className={classes.listItem}>
        <CustomDropdown
          noLiPadding
          buttonText="Others"
          buttonProps={{
            className: classes.navLink,
            color: "transparent",
          }}
          buttonIcon={Apps}
          dropdownList={[
            <Link
              to="/mentorship"
              color="transparent"
              className={classes.navLink}
            >
              <Person className={classes.icons} />
              Mentorship
            </Link>,
            <Link to="/myprofile" color="rose" className={classes.navLink}>
              <Face className={classes.icons} />
              Profile
            </Link>,
            <Link
              to="/sayhello"
              color="transparent"
              className={classes.navLink}
            >
              <Contactless className={classes.icons} />
              Hello
            </Link>,
            <a
              href={MyResume}
              rel="noopener noreferrer"
              target="_blank"
              color="rose"
              className={classes.navLink}
            >
              <Subject className={classes.icons} /> My Resume
            </a>,
          ]}
        />
      </ListItem>
      <ListItem className={classes.listItem}>
        <Tooltip
          id="instagram-tooltip"
          title="Follow me on linkedin"
          placement={window.innerWidth > 959 ? "top" : "left"}
          classes={{ tooltip: classes.tooltip }}
        >
          <a
            rel="noopener noreferrer"
            color="transparent"
            href="https://www.linkedin.com/in/rachit-mehrotra-io/"
            target="_blank"
            className={classes.navLink}
          >
            <i className={classes.socialIcons + " fab fa-linkedin"} />
          </a>
        </Tooltip>
      </ListItem>
      <ListItem className={classes.listItem}>
        <Tooltip
          id="medium-tooltip"
          title="Follow me on medium"
          placement={window.innerWidth > 959 ? "top" : "left"}
          classes={{ tooltip: classes.tooltip }}
        >
          <Button
            color="transparent"
            href="https://rachitmehrotra-io.medium.com/"
            target="_blank"
            className={classes.navLink}
          >
            <i className={classes.socialIcons + " fab fa-medium"} />
          </Button>
        </Tooltip>
      </ListItem>
    </List>
  );
}
